import type { AssetDefender } from '@/types/oscar';

export interface DefenderBadge { text: string; tone: 'ok' | 'warn' | 'muted' }

/**
 * The short label shown under a Windows device's name. It is INTUNE'S view of Defender (protection on, signatures
 * current, nothing pending), so it says "per Intune" and never "protected" or "secure": the risk score and
 * exposure level live in the Defender portal. "Not reported" is neither good nor bad news, and is never shown as
 * healthy.
 */
export function defenderBadge(d: Pick<AssetDefender, 'Health'>): DefenderBadge {
  switch (d.Health) {
    case 'healthy': return { text: 'Defender healthy (per Intune)', tone: 'ok' };
    case 'attention': return { text: 'Defender needs attention', tone: 'warn' };
    default: return { text: 'Defender not reported', tone: 'muted' };
  }
}

/** A protection flag as a person says it. A flag Intune left out is "Not reported", never "Off". */
export function onOff(value: boolean | null): string {
  if (value === null) return 'Not reported';
  return value ? 'On' : 'Off';
}

/** An "overdue" flag as a person says it. Null is "Not reported", never "Up to date". */
export function overdue(value: boolean | null): string {
  if (value === null) return 'Not reported';
  return value ? 'Overdue' : 'Up to date';
}
